var map = {
	"./avatar1.png": "789f",
	"./avatar2.png": "35e5",
	"./avatar3.png": "35e9",
	"./bnk-logo.png": "0c5e",
	"./main-top.svg": "b6fc",
	"./manual/bank_save_image.jpg": "3075",
	"./woori/funda-logo-white.png": "18e6",
	"./woori/gov-smes-full.png": "8038"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c3e";